import { render, staticRenderFns } from "./VR.vue?vue&type=template&id=3cd9dc79&scoped=true"
import script from "./VR.vue?vue&type=script&lang=js"
export * from "./VR.vue?vue&type=script&lang=js"
import style0 from "./VR.vue?vue&type=style&index=0&id=3cd9dc79&prod&scoped=true&lang=css"
import style1 from "./VR.vue?vue&type=style&index=1&id=3cd9dc79&prod&lang=css"
import style2 from "./VR.vue?vue&type=style&index=2&id=3cd9dc79&prod&lang=css"
import style3 from "./VR.vue?vue&type=style&index=3&id=3cd9dc79&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd9dc79",
  null
  
)

export default component.exports